import { Link } from 'react-router-dom'
import { useCartStore, selectTotalPrice } from '@store/useCartStore'
import './CartDrawer.scss'

export default function CartDrawer({ open, onClose }) {
  const items = useCartStore((s) => s.items)
  const removeItem = useCartStore((s) => s.removeItem)
  const updateQty = useCartStore((s) => s.updateQty)
  const totalPrice = useCartStore(selectTotalPrice)

  return (
    <>
      <div className={`cart-overlay ${open ? 'is-open' : ''}`} onClick={onClose} />

      <aside className={`cart-drawer ${open ? 'is-open' : ''}`}>
        <div className="cart-header">
          <h3>Coșul tău</h3>
          <button className="cart-close" onClick={onClose} aria-label="Închide">
            ✕
          </button>
        </div>

        {items.length === 0 ? (
          <div className="cart-empty">
            <p>Coșul tău este gol.</p>
            <Link to="/shop" className="btn-primary" onClick={onClose}>
              Descoperă produsele
            </Link>
          </div>
        ) : (
          <>
            <ul className="cart-items">
              {items.map((item) => {
                const key = `${item.productId}-${item.variantName ?? 'default'}`
                return (
                  <li key={key} className="cart-item">
                    {item.productImage && (
                      <img
                        src={item.productImage}
                        alt={item.productName}
                        className="cart-item-img"
                      />
                    )}
                    <div className="cart-item-info">
                      <span className="cart-item-name">{item.productName}</span>
                      {item.variantName && (
                        <span className="cart-item-variant">{item.variantName}</span>
                      )}
                      <span className="cart-item-price">{item.unitPrice} lei</span>
                    </div>
                    <div className="cart-item-qty">
                      <button
                        onClick={() => updateQty(item.productId, item.variantName, item.quantity - 1)}
                        aria-label="Minus"
                      >
                        −
                      </button>
                      <span>{item.quantity}</span>
                      <button
                        onClick={() => updateQty(item.productId, item.variantName, item.quantity + 1)}
                        aria-label="Plus"
                      >
                        +
                      </button>
                    </div>
                    <button
                      className="cart-item-remove"
                      onClick={() => removeItem(item.productId, item.variantName)}
                      aria-label="Elimină"
                    >
                      ✕
                    </button>
                  </li>
                )
              })}
            </ul>

            <div className="cart-footer">
              <div className="cart-total">
                <span>Subtotal</span>
                <span>{Math.round(totalPrice * 100) / 100} lei</span>
              </div>
              <Link to="/checkout" className="btn-primary cart-checkout-btn" onClick={onClose}>
                Finalizează comanda
              </Link>
            </div>
          </>
        )}
      </aside>
    </>
  )
}
